import { FilterChipBar } from "./FilterChipBar";
import { listStageLabels, type StageLike } from "@/lib/stageFilterUi";

type StageFilterBarProps = {
  // Stages currently available for the selected day. Labels are deduped
  // internally, so callers can pass the raw on-screen stage list.
  stages: StageLike[];
  // Selected stage labels (empty = no filter, show all).
  selected: ReadonlySet<string>;
  onToggle: (label: string) => void;
  onClear: () => void;
};

/**
 * "Filter by stage" chips, used by both the schedule creator (CrewSchedule)
 * and the read-only producer view (ReadOnlyScheduleTimeline) so the two
 * screens filter identically.
 */
export function StageFilterBar({ stages, ...rest }: StageFilterBarProps) {
  return (
    <FilterChipBar
      options={listStageLabels(stages)}
      title="Filter by stage"
      testIdPrefix="stage-filter"
      {...rest}
    />
  );
}
